import { Calendar, Views, dateFnsLocalizer } from 'react-big-calendar'
import React from "react";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {toast} from "react-toastify";
import Panel from '../../common/portal/Panel'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import enUS from 'date-fns/locale/en-US'
import UpdateEvent from './updateEvent'
import CreateEvent from './createEvent'
import {zonedTimeToUtc} from "date-fns-tz";
import Tabs from '../../common/Tabs'
import { getList } from '../../common/v4/BackendProvider';
const propTypes = {}


class CreateEventWithNoOverlap extends React.Component {
    constructor(...args) {
        super(...args)
        this.campaign_id = window.location.pathname.split('/').pop();

        this.state = {
            events: [],
            createEventModal: false,
            showStop: false,
            updateEventModal: false,
            selectedEvent: {},
            newStart: undefined,
            newEnd: undefined,
            metadata: {campaigns: [], lists: []}
        }
    }
    componentDidMount(){
        this.loadFromServer();
    }
    loadFromServer() {
        const url = '/admin/campaigns/scheduler/metadata';
        const filter = this.state.filter;
        const params = {};
        params.filter = [];
        if (filter !== undefined) {
            params.filter = filter;
        }
        getList(url, params, this.props).then(
            response => {
                if (response.data !== undefined) {
                    let events = response.data.data.events;
                    let updatedEvents = [];
                    events.map(function (col, key) {
                        let ev = {
                            title: col.title,
                            start: zonedTimeToUtc(new Date(col.start), "UTC"),
                            end: zonedTimeToUtc(new Date(col.end), "UTC"),
                            allDay: false,
                            editable: col.editable,
                            status: col.status,
                            campaignId: col.campaignId,
                            eventId: col.id
                        };
                        updatedEvents.push(ev);
                    });
                    this.setState({
                        loading: false,
                        metadata: response.data.metadata,
                        events: updatedEvents
                    })
                } else {
                    toast.error("Something went wrong... backend not reachable. Try to reload page", {})
                }
            }
        ).catch(error => {
            toast.error("Something went wrong... backend not reachable. Try to reload page", {})
        });
    }
    handleSelect = ({ start, end }) => {
        if (start.getTime() + 86400000 > new Date().getTime()) {
            this.setState(prevState => ({
                newStart: start,
                newEnd: end,
                createEventModal: true
            }))
        } else {
            toast.error("The date is in the past. Cannot create event here", {})
        }
    };
    handleUpdateClose = () => {
        this.setState({ updateEventModal: false}, this.loadFromServer)
    }
    handleCreateClose = () => {
        this.setState({
            createEventModal: false,
            newStart: undefined,
            newEnd: undefined,
        }, this.loadFromServer)
    }
    handleEventClick(event) {
        this.setState({
            updateEventModal: true,
            selectedEvent: event
        })
    }
    errorMessage(message) {
        if (message === undefined) {
            return "Backend Error";
        }
        let errstr = message.msg;
        errstr = (errstr === undefined) ? "Backend Error": errstr;
        this.setState((state) => ({
            errors: message
        }));
        return errstr;
    }
    render() {
        let prefs = {};       
        const {events, showStop, metadata, updateEventModal, selectedEvent, createEventModal, newStart, newEnd} = this.state;
        const tabs = [
        {
            link: '/campaigns/campaigns',
            name: 'Campaigns'
        },
        {
            link: '/campaigns/scheduler',
            name: 'Scheduler'
        }
    ]
        
        const locales = {
            'en-US': enUS
        }

        let localizer = dateFnsLocalizer({
            format,
            parse,
            startOfWeek,
            getDay,
            locales,
        })

        return (
            <>
                <UpdateEvent
                    updateEventModal={updateEventModal}
                    event={selectedEvent}
                    metadata={metadata}
                    prefs={prefs}
                    onModalCose={this.handleUpdateClose}
                />

                <CreateEvent
                    createEventModal={createEventModal}
                    start={newStart}
                    end={newEnd}
                    event={selectedEvent}
                    metadata={metadata}
                    prefs={prefs}
                    onModalCose={this.handleCreateClose}
                />

                <Panel title="Scheduler">
                    <>
                        <Tabs tabs={tabs} />
                        <Calendar
                            selectable
                            localizer={localizer}
                            events={events}
                            defaultView={Views.MONTH}
                            scrollToTime={new Date()}
                            defaultDate={new Date()}
                            onSelectEvent={event => this.handleEventClick(event) }
                            onSelectSlot={this.handleSelect}
                            style={{ height: 500 }}
                            dayLayoutAlgorithm={this.state.dayLayoutAlgorithm}
                        />
                    </>
                </Panel>
            </>
        )
    }
}

CreateEventWithNoOverlap.propTypes = propTypes;

export default CreateEventWithNoOverlap
